import { ChangeEvent, createContext, useContext } from "react";

interface RadioGroupContextBody {
    value?: string;
    onChange?(event: ChangeEvent<HTMLInputElement>): void;
}

const RadioGroupContext = createContext<RadioGroupContextBody | null>(null);
export const RadioGroupProvider = RadioGroupContext.Provider;
export const useRadioGroupContext = () => useContext(RadioGroupContext);